import { render, staticRenderFns } from "./materialReplace.vue?vue&type=template&id=c1d7d142&scoped=true"
import script from "./materialReplace.vue?vue&type=script&lang=js"
export * from "./materialReplace.vue?vue&type=script&lang=js"
import style0 from "./materialReplace.vue?vue&type=style&index=0&id=c1d7d142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d7d142",
  null
  
)

export default component.exports